import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Popover} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jxs",
        "metastring": "live",
        "live": true
      }}>{`<Box position="relative">
  <Box justifyContent="center" display="flex">
    <Button variant="primary">Hello!</Button>
  </Box>

  <Popover relative open={true} caret="top">
    <Popover.Content sx={{mt: 2}}>
      <Heading sx={{fontSize: 2}}>Popover heading</Heading>
      <Text as="p">Message about this particular piece of UI.</Text>
      <Button>Got it!</Button>
    </Popover.Content>
  </Popover>
</Box>
`}</code></pre>
    <p>{`Two components make up a popover; the `}<inlineCode parentName="p">{`Popover`}</inlineCode>{` component controls the absolute positioning of the popover, and `}<inlineCode parentName="p">{`Popover.Content`}</inlineCode>{` renders the inner content of the popover as well as the caret.`}</p>
    <p>{`By default, the popover renders with absolute positioning, meaning it should usually be wrapped in an element with a relative position in order to be positioned properly. To render the popover with relative positioning, use the `}<inlineCode parentName="p">{`relative`}</inlineCode>{` property.`}</p>
    <p>{`It can be useful to give the `}<inlineCode parentName="p">{`Popover.Content`}</inlineCode>{` element a margin to help align the popover.`}</p>
    <h3>{`Caret position`}</h3>
    <p><inlineCode parentName="p">{`Popover`}</inlineCode>{` supports various caret positions, which you can specify via the `}<inlineCode parentName="p">{`caret`}</inlineCode>{` property. This demo shows all the valid values for the prop. The default is `}<inlineCode parentName="p">{`top`}</inlineCode>{`. Note that the `}<inlineCode parentName="p">{`top-left`}</inlineCode>{`, `}<inlineCode parentName="p">{`bottom-left`}</inlineCode>{`, `}<inlineCode parentName="p">{`top-right`}</inlineCode>{`, and `}<inlineCode parentName="p">{`bottom-right`}</inlineCode>{` values modify the horizontal alignment of the popover.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`function PopoverDemo(props) {
  const [pos, setPos] = React.useState('top')
  const [open, setOpen] = React.useState(true)

  return (
    <Box>
      <Heading as="h3" sx={{fontSize: 3}}>
        Caret Position
      </Heading>
      <CaretSelector current={pos} onChange={setPos} />
      <Heading as="h3" sx={{fontSize: 3}}>
        Popover Visibility
      </Heading>
      <Box my={2}>
        <label>
          <input type="checkbox" value={open} checked={open} onChange={() => setOpen(open => !open)} /> Open
        </label>
      </Box>

      <Box position="relative" pt={4}>
        <Popover relative open={open} caret={pos}>
          <Popover.Content>
            <Heading sx={{fontSize: 2}}>
              <code>{pos}</code> caret
            </Heading>
            <Text as="p">Message about this particular piece of UI.</Text>
            <Button onClick={() => setOpen(false)}>Got it!</Button>
          </Popover.Content>
        </Popover>
      </Box>
    </Box>
  )
}

function CaretSelector(props) {
  const choices = [
    'top',
    'bottom',
    'left',
    'right',
    'left-bottom',
    'left-top',
    'right-bottom',
    'right-top',
    'top-left',
    'bottom-left',
    'top-right',
    'bottom-right'
  ].map(dir => (
    <label>
      <input
        key={dir}
        type="radio"
        name="caret"
        value={dir}
        checked={dir === props.current}
        onChange={() => props.onChange(dir)}
      />{' '}
      {dir}
    </label>
  ))

  return (
    <Box display="grid" gridTemplateColumns="repeat(4, auto)" gridGap={3} my={2}>
      {choices}
    </Box>
  )
}

render(<PopoverDemo />)
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`Popover`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="as" defaultValue="div" type="string" description="Sets the underlying HTML tag for the component" mdxType="PropsTableRow" />
  <PropsTableRow name="caret" defaultValue="'top'" type={`| 'top'
| 'bottom'
| 'left'
| 'right'
| 'bottom-left'
| 'bottom-right'
| 'top-left'
| 'top-right'
| 'left-bottom'
| 'left-top'
| 'right-bottom'
| 'right-top'
  `} description="Controls the position of the caret" mdxType="PropsTableRow" />
  <PropsTableRow name="open" defaultValue="false" type="boolean" description="Controls the visibility of the popover." mdxType="PropsTableRow" />
  <PropsTableRow name="relative" defaultValue="false" type="boolean" description="Set to true to render the popover using relative positioning. " mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`Popover.Content`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="as" defaultValue="div" type="string" description="Sets the underlying HTML tag for the component" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      